<div class="container-fluid ">
    <div class="row">
        <app-sidebar></app-sidebar>
        <div class="wrap admin-bg">
            <div class="col-md-12 px-0">
                <app-header></app-header>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
